var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-block richtext"},[(_vm.data.title)?_c('h2',{staticClass:"text-block__title"},[_vm._v(_vm._s(_vm.data.title))]):_vm._e(),_c('div',{staticClass:"text-block__content",domProps:{"innerHTML":_vm._s(_vm.data.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }